import { atom } from 'jotai';
import { NewReportForm } from '../lib/schemas';

interface State {
  isOpen: boolean;
  report?: NewReportForm;
}

export const createReportOverviewDialogAtom = atom<State>({ isOpen: false, report: undefined });
